var _rect, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionsLinkHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.51367,
    y: 1,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#1756E8",
    stroke: "#1756E8",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5137,
    cy: 7,
    r: 2,
    transform: "rotate(90 14.5137 7)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5137,
    cy: 13,
    r: 2,
    transform: "rotate(90 14.5137 13)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5137,
    cy: 19,
    r: 2,
    transform: "rotate(90 14.5137 19)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionsLinkHover);
export default __webpack_public_path__ + "static/media/optionsLinkHover.bffab2f98a3a339300ad319515cb8fbe.svg";
export { ForwardRef as ReactComponent };